import { useEffect } from "react";
import api from "@/lib/api";

function hexToRgb(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec((hex || "").trim());
  if (!m) return null;
  return [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)];
}

function rgbToHsl([r, g, b]) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h /= 6;
  }
  return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
}

function apply(theme) {
  const root = document.documentElement;
  const primary = theme?.primary || "#D81B4A";
  const dark = theme?.primary_dark || "#B0153B";
  const rgb = hexToRgb(primary);
  if (!rgb) return;
  root.style.setProperty("--rgh-primary", primary);
  root.style.setProperty("--rgh-primary-rgb", rgb.join(" "));
  root.style.setProperty("--rgh-primary-dark", dark);
  const [h, s, l] = rgbToHsl(rgb);
  const hsl = `${h} ${s}% ${l}%`;
  // Drive the shadcn app theme (login, portal, inventory, clinic) too
  root.style.setProperty("--primary", hsl);
  root.style.setProperty("--ring", hsl);
  root.style.setProperty("--sidebar-primary", hsl);
  root.style.setProperty("--sidebar-ring", hsl);
}

export default function ThemeInjector() {
  useEffect(() => {
    let cancel = false;
    api.get("/site/content").then(({ data }) => { if (!cancel) apply(data.theme); }).catch(() => {});
    return () => { cancel = true; };
  }, []);
  return null;
}
